// extracted by mini-css-extract-plugin
export default {"empty":"PdbIgSN9ZgH7yhN_3EgF"};